/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createMatrixClass } from '../../factoriesAny.js';
export var MatrixDependencies = {
  createMatrixClass: createMatrixClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesMatrixClass.generated.js
// module id = 232
// module chunks = 0